var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-4" },
    [
      _c(
        "document-type-header",
        {
          attrs: {
            title: _vm.$t("iframe_page.doctypes.proof_address"),
            statusLabel: _vm.statusLabel,
            statusIcon: _vm.statusIcon,
            subTitle: _vm.subTitle,
          },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("iframe_page.docinfo.proof_address")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("list-dropdown", {
        attrs: {
          placeholder: _vm.$t("iframe_page.doctypes.inform_justificatif"),
          options: [
            _vm.$t("iframe_page.docinfo.bill"),
            _vm.$t("iframe_page.docinfo.rent_receipt"),
            _vm.$t("iframe_page.docinfo.sworn_statement"),
          ],
        },
        on: { input: _vm.changeListType },
        model: {
          value: _vm.type,
          callback: function ($$v) {
            _vm.type = $$v
          },
          expression: "type",
        },
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.type === _vm.$t("iframe_page.docinfo.sworn_statement")
        ? _c(
            "div",
            [
              _c("document-type-form", {
                attrs: {
                  multipleDocs: "",
                  docType: "Declaration",
                  idDocument: _vm.declareHostDocs,
                  name: "docTypeFormProof",
                  onValidate: _vm.validateButton,
                  subTitle: _vm.$t("iframe_page.docinfo.sworn_statement"),
                  title: _vm.$t("iframe_page.docinfo.sworn_statement"),
                },
                model: {
                  value: _vm.declareDocs,
                  callback: function ($$v) {
                    _vm.declareDocs = $$v
                  },
                  expression: "declareDocs",
                },
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("document-type-form", {
                attrs: {
                  multipleDocs: "",
                  docType: "IdCardHost",
                  idDocument: _vm.idHostDoc,
                  onValidate: _vm.validateButton,
                  name: "docTypeFormIdHost",
                  subTitle: _vm.$t("iframe_page.docinfo.id_host"),
                  title: _vm.$t("iframe_page.docinfo.id_host"),
                },
                model: {
                  value: _vm.idHostDocs,
                  callback: function ($$v) {
                    _vm.idHostDocs = $$v
                  },
                  expression: "idHostDocs",
                },
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("document-type-form", {
                attrs: {
                  multipleDocs: "",
                  docType: "ProofAdress",
                  idDocument: _vm.proofAdressDoc,
                  name: "docTypeFormProofAdress",
                  subTitle: _vm.$t("iframe_page.docinfo.proof_address_host"),
                  title: _vm.$t("iframe_page.docinfo.proof_address_host"),
                },
                model: {
                  value: _vm.proofHostDocs,
                  callback: function ($$v) {
                    _vm.proofHostDocs = $$v
                  },
                  expression: "proofHostDocs",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === _vm.$t("iframe_page.docinfo.bill")
        ? _c(
            "div",
            [
              _c("document-type-form", {
                attrs: {
                  multipleDocs: "",
                  docType: "Bill",
                  idDocument: _vm.billDoc,
                  name: "docTypeFormBill",
                  subTitle: _vm.$t("iframe_page.docinfo.bill"),
                  title: _vm.$t("iframe_page.docinfo.bill"),
                },
                model: {
                  value: _vm.billDocs,
                  callback: function ($$v) {
                    _vm.billDocs = $$v
                  },
                  expression: "billDocs",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === _vm.$t("iframe_page.docinfo.rent_receipt")
        ? _c(
            "div",
            [
              _c("document-type-form", {
                attrs: {
                  multipleDocs: "",
                  docType: "Receipe",
                  idDocument: _vm.receipeDoc,
                  name: "docTypeFormReceipe",
                  subTitle: _vm.$t("iframe_page.docinfo.rent_receipt"),
                  title: _vm.$t("iframe_page.docinfo.rent_receipt"),
                },
                model: {
                  value: _vm.billDocs,
                  callback: function ($$v) {
                    _vm.billDocs = $$v
                  },
                  expression: "billDocs",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }